export default __webpack_public_path__ + "static/media/rail.fd40d11e.svg";